// DiceBear identicon の URL を生成する（ペアリング/action の視覚識別用）。
// 旧 avatars.dicebear.com/api は廃止されたため v10 の shape-grid を使う。
export const dicebearUrl = (seed: string | number): string =>
	`https://api.dicebear.com/10.x/shape-grid/svg?seed=${seed}`
